import { Injectable } from '@angular/core';
import { Router } from '@angular/router';  
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { LoginResponse } from '../modules/shared/interfaces/login-response.type';


/** Pass the request after appending origin url with protocol. */
@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && (event.status / 100) > 3) {
          console.warn(`[RefreshTokenInterceptor] HttpResponse:: Status: ${event.status}`, event);
        }
        return event;
      }),
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {

          console.warn(`[RefreshTokenInterceptor] Error HTTP Response: Status: ${error.status}, url: ${req.url}`);
          if (error.status === 403) {
            const currentUrl = this.router.url;
            console.warn(`[RefreshTokenInterceptor] 403 → navigating to admin/access-denied. currentUrl: ${currentUrl}, reqUrl: ${req.url}`);
            this.router.navigate(['admin/access-denied'], { queryParams: { returnUrl: currentUrl } });
          }

          // We don't want to refresh token for some requests like login or refresh token itself
          // So we verify url and we throw an error if it's the case
          if (req.url.includes('entrance/refresh-login-token') || req.url.includes('entrance/login') || req.url.includes('entrance/login-as-oauth-client')) {
            // We do another check to see if refresh token failed
            // In this case we want to logout user and to redirect it to login page
            if (req.url.includes('entrance/refresh-login-token')) {
              console.warn(`[RefreshTokenInterceptor] refresh-login-token failed with ${error.status} → calling logout(). Stack:`, new Error().stack);
              this.authService.logout();
            }
            return throwError(error);
          }

          if (error.status == 401) {
            return this.handle401Error(req, next);
          }        
          
          return throwError(error);
          
        }
        return throwError(error);
      }));

  }


  private handle401Error(req: HttpRequest<any>, next: HttpHandler) {

    console.warn(`[RefreshTokenInterceptor] handle401Error → req.url:`, req.url);

    return this.authService.refreshIfNeeded().pipe(
      switchMap((tokenData: LoginResponse) => {
        const authenticatedReq = this.sendAuthenticatedRequest(req, tokenData);
        console.warn('[RefreshTokenInterceptor] Retrying after refresh:', authenticatedReq.url);
        return next.handle(authenticatedReq);
      }),
      catchError((err) => {
        console.error(`[RefreshTokenInterceptor] handle401Error catchError → logout(). originalUrl: ${req.url}, error:`, err, 'Stack:', new Error().stack);
        this.authService.logout();
        return throwError(err);
      })
    );
  }

  private sendAuthenticatedRequest(req: HttpRequest<any>, tokenData: LoginResponse) {
    console.warn('Sending the Pending Requests, After Access Token Refresh:', req.url);
    return req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + tokenData.accessToken)
    });
  }

}
